/*
 * Counterpoint, 22 Oct 2026 (add on 3). Still carousel with a fixed text overlay (snippets/cp-carousel.liquid).
 * Arrows, dots, swipe and arrow keys. It moves on by itself every data-interval ms until the first click, tap,
 * swipe or key press, then stops for good. With reduced motion it never moves on by itself. Slides after the
 * first get their image sources once the page has loaded.
 */
(function () {
  'use strict';

  var reduced = false;
  try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function loadRest(root) {
    var lazy = root.querySelectorAll('[data-srcset], [data-src]');
    for (var i = 0; i < lazy.length; i++) {
      var el = lazy[i];
      if (el.hasAttribute('data-srcset')) { el.setAttribute('srcset', el.getAttribute('data-srcset')); el.removeAttribute('data-srcset'); }
      if (el.hasAttribute('data-src')) { el.setAttribute('src', el.getAttribute('data-src')); el.removeAttribute('data-src'); }
    }
  }

  function init(root) {
    if (root.hasAttribute('data-cp-carousel-ready')) return;
    root.setAttribute('data-cp-carousel-ready', '');
    var slides = root.querySelectorAll('[data-cp-carousel-slide]');
    var dots = root.querySelectorAll('[data-cp-carousel-dot]');
    if (slides.length < 2) return;
    var index = 0;
    var timer = null;
    var stopped = false;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;

    function show(i) {
      index = (i + slides.length) % slides.length;
      for (var s = 0; s < slides.length; s++) {
        var on = s === index;
        slides[s].classList.toggle('is-active', on);
        if (on) slides[s].removeAttribute('aria-hidden'); else slides[s].setAttribute('aria-hidden', 'true');
      }
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === index);
        if (d === index) dots[d].setAttribute('aria-current', 'true'); else dots[d].removeAttribute('aria-current');
      }
    }

    function stop() {
      stopped = true;
      if (timer) { clearInterval(timer); timer = null; }
      root.setAttribute('data-cp-carousel-stopped', '');
    }

    function start() {
      if (reduced || stopped || timer) return;
      timer = setInterval(function () { if (!document.hidden) show(index + 1); }, interval);
    }

    // Any click in the carousel stops it for good, on the image as well as on the controls.
    root.addEventListener('click', function (e) {
      var prev = e.target.closest('[data-cp-carousel-prev]');
      var next = e.target.closest('[data-cp-carousel-next]');
      var dot = e.target.closest('[data-cp-carousel-dot]');
      stop();
      if (prev) show(index - 1);
      else if (next) show(index + 1);
      else if (dot) show(Array.prototype.indexOf.call(dots, dot));
    });

    root.addEventListener('keydown', function (e) {
      if (e.target !== root && !e.target.closest('[data-cp-carousel-dot], [data-cp-carousel-prev], [data-cp-carousel-next]')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); stop(); show(index - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); stop(); show(index + 1); }
    });

    // Swipe: a mostly sideways move of 40 px or more. Taps on the text and its button are left alone.
    var x0 = null, y0 = null;
    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' || e.target.closest('a, button')) { x0 = null; return; }
      x0 = e.clientX; y0 = e.clientY;
    });
    root.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      x0 = null;
      if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) { stop(); show(index + (dx < 0 ? 1 : -1)); }
      else if (Math.abs(dx) < 10 && Math.abs(dy) < 10) { stop(); }
    });
    root.addEventListener('pointercancel', function () { x0 = null; });

    if (document.readyState === 'complete') loadRest(root);
    else window.addEventListener('load', function () { loadRest(root); });

    // Theme editor: selecting a slide block shows it and stops the timer.
    root.addEventListener('shopify:block:select', function (e) {
      var i = Array.prototype.indexOf.call(slides, e.target);
      if (i > -1) { stop(); show(i); }
    });

    start();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-cp-carousel]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
